import { TicketType } from "webshop-api";
import { TicketTypeMaximumAmountProvider, TicketTypeState } from "@/domain/ticket-selection";

export class TicketTypeStateMapper {

    /**
     * whatItDoes
     * maps TicketType entity to TicketTypeState
     */
    public static fromTicketType(object: TicketType, applicationTicketMaximum: number): TicketTypeState {
        const maximum = TicketTypeMaximumAmountProvider.getMaximumFor(object, applicationTicketMaximum);
        const minimum = object.minTicketsPerOrder || 0;

        return {
            ticketTypeID: object.ticketTypeID!,
            priceId: object.priceId!,
            price: object.price ?? 0,
            text: object.text ?? '-',
            amount: 0,
            canIncrease: maximum > 0 && maximum >= minimum,
            canDecrease: false,
            max: maximum,
            min: minimum,
            step: object.onlyInGroupsOfPerOrder ? object.onlyInGroupsOfPerOrder : 1,
        };
    }

}
